import { api, API_BASE_URL } from '../../api/client';

export const API_URL = API_BASE_URL;
export const DEFAULT_OUTDOOR_RATE_CENTS = 2000;
export const DEFAULT_INDOOR_RATE_CENTS = 3000;

export interface EditableCourt {
  id: string;
  name: string;
  externalName?: string;
  type: string;
  sport: string;
  isActive: boolean;
  hourlyRateCents: number;
}

export function getVenueQuery(): string {
  const venueId = api.getSelectedVenueId();
  return venueId ? `?venueId=${venueId}` : '';
}

export function getAuthToken(): string {
  return api.getToken()
    || localStorage.getItem('auth_token')
    || localStorage.getItem('okc_auth_token')
    || '';
}

export function buildEditableCourts(
  courts: any[],
  defaultRateCents: number
): EditableCourt[] {
  return (courts || []).map((court: any) => ({
    ...court,
    externalName: court.externalName || court.name,
    hourlyRateCents: Number.isFinite(Number(court.hourlyRateCents))
      ? Number(court.hourlyRateCents)
      : defaultRateCents
  }));
}
